import usersReducer from './slices';

// Users Actions
export { getUsersList, createUser, updateUser } from './usersActions';

// Users Selector
export const usersSelector = (state) => state.users.usersList.users;

// Users Reducer
export default usersReducer;
